export class CarRentalItemFareVO {
  constructor(description, amount, currency, taxInclusive, taxAmounts) {
    this.description = description;
    this.amount = amount;
    this.currency = currency;
    this.taxInclusive = taxInclusive;
    this.taxAmounts = taxAmounts;
  }
}
